import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useLanguage } from '../../contexts/LanguageContext';

/** Visible toast card — white box, border, shadow (not bare text). */
const TOAST_CARD =
  '!max-w-md !rounded-2xl !border !border-slate-200 !bg-white !px-4 !py-3.5 !text-sm !font-medium !leading-snug !text-slate-900 !shadow-lg !shadow-slate-900/10 dark:!border-slate-700 dark:!bg-slate-900 dark:!text-slate-50 dark:!shadow-black/30';

const TOAST_TYPES = {
  success: {
    className: `${TOAST_CARD} !border-emerald-200 dark:!border-emerald-800/60`,
    iconTheme: { primary: '#059669', secondary: '#ffffff' },
  },
  error: {
    className: `${TOAST_CARD} !border-red-200 dark:!border-red-800/60`,
    iconTheme: { primary: '#dc2626', secondary: '#ffffff' },
  },
  loading: {
    className: `${TOAST_CARD} !border-slate-200 dark:!border-slate-700`,
  },
  blank: {
    className: `${TOAST_CARD}`,
  },
};

export default function AppToaster() {
  const { isRTL } = useLanguage();

  return (
    <Toaster
      position={isRTL ? 'top-left' : 'top-right'}
      containerClassName="!z-[9999] !top-20 sm:!top-4"
      gutter={12}
      toastOptions={{
        duration: 4500,
        className: TOAST_CARD,
        success: TOAST_TYPES.success,
        error: TOAST_TYPES.error,
        loading: TOAST_TYPES.loading,
        blank: TOAST_TYPES.blank,
      }}
    />
  );
}
